import { BUSINESS_ID } from '@gumtree/ui-library/src/utils/suggestions-service-g5s';

export type G5SParams = { busId: number; timeStamp: string; sign: string };

export const defaultState: G5SParams = {
    busId: BUSINESS_ID,
    timeStamp: '',
    sign: '',
};

export default (state = defaultState, action: { type: string; params: G5SParams }) => {
    switch (action.type) {
        case 'SET_G5S_PARAMS':
            return Object.assign({}, state, {
                busId: action.params.busId,
                timeStamp: action.params.timeStamp,
                sign: action.params.sign,
            });
        default:
            return state;
    }
};
